// extracted by mini-css-extract-plugin
module.exports = {"battery-backup-Retailers":"Retailers_battery-backup-Retailers__BGfMy"};